module.exports = __webpack_public_path__ + "static/media/Q-Diamond.5a4b4a3d.svg";